const groupQueryKeys = {
  all: ['group'] as const,
  list: (
    orderBy: any,
    filters: any,
    queryPageSize: number,
    queryPageIndex: number,
  ) =>
    [
      ...groupQueryKeys.all,
      'list',
      orderBy,
      filters,
      queryPageSize,
      queryPageIndex,
    ] as const,
  byId: (id: string | undefined) => [...groupQueryKeys.all, id] as const,
};

export default groupQueryKeys;
